const translations = {
  welcome: 'Bem-vindo',
  exit: 'Sair',
  trainingActivity: 'Sua Atividade de Treino',
  less: 'Menos',
  more: 'Mais',
  todaySchedule: 'Agenda de Hoje em {{facility}}',
  noClasses: 'Não há aulas programadas para hoje',
  loadingSchedule: 'Carregando agenda...',
  loadingActivity: 'Carregando gráfico de atividade...',
  loadingHistory: 'Carregando histórico de presenças...',
  duration: 'Duração: {{minutes}} minutos',
  registerClass: 'Registrar para Aula',
  registerConfirm: 'Gostaria de se registrar para esta aula de {{className}}?',
  cancel: 'Cancelar',
  register: 'Registrar',
  registering: 'Registrando...',
  recentAttendances: 'Presenças Recentes',
  noHistory: 'Nenhum histórico de presenças encontrado',
  tableHeaders: {
    date: 'Data',
    class: 'Aula',
    timeCreated: 'Hora Criada',
    status: 'Status'
  },
  status: {
    graduated: '🎓 Graduado',
    active: '✅ Ativo'
  },
  errors: {
    fetchSlots: 'Erro ao carregar sua agenda. Por favor tente novamente mais tarde.',
    registration: 'Erro ao registrar para a aula. Por favor tente novamente.'
  },
  success: {
    registration: 'Registrado com sucesso para a aula!'
  }
} as const;

export type TranslationType = typeof translations;
export default translations; 